import React from 'react';
import { itvThemeColor, tabletMediaQuery, themeColor } from '../../Theming';
import styled from 'styled-components';
import { Close } from '../../Common/Svg/Icons';
import { useTranslation } from 'react-i18next';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 64px;
  background-color: ${itvThemeColor('greenishBlue')};
  justify-content: space-between;
  padding-inline: 20px;

  ${tabletMediaQuery} {
    height: 48px;
  }
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: Bold;
  justify-content: center;
  font-family: Arial;
  padding-inline: 13px;
  flex: 1;

  &.aligned-center {
    align-items: center;
    flex: 2 !important;
  }

  &.aligned-right {
    align-items: flex-end;
  }
`;

const Text = styled.span`
  font-size: 18px;
  color: ${themeColor('white')};
`;

const CloseIcon = styled.div`
  cursor: pointer;
`;

interface CashSaverHeaderProps {
  onClose?: () => void;
}

const CashSaverHeader: React.FC<CashSaverHeaderProps> = ({ onClose }) => {
  const { t } = useTranslation();
  return (
    <Container>
      <Section />
      <Section className="aligned-center">
        <Text>{t('extension.itvActivation.header.cashSaver')}</Text>
      </Section>
      <Section className="aligned-right">
        <CloseIcon onClick={onClose}>
          <Close width={16} height={16} strokeWidth={3} color="#fff" />
        </CloseIcon>
      </Section>
    </Container>
  );
};

export default CashSaverHeader;
